
// components/home/PublicationsCarousel.js
import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

// Styles pour le carrousel
const PublicationsCarousel = ({ publications = [], responsive }) => {
  
  return (
    <Carousel
      responsive={responsive}
      autoPlay={true}
      infinite={true}
      showDots={false}
      duration={10000}
      containerClass="carousel-container"
      itemClass="px-2"
      additionalTransfrom={0}
      keyBoardControl={true}
      pauseOnHover
      swipeable
      draggable
    >
      {publications && publications.length > 0 ? (
        // 🔹 Afficher les vraies publications
        publications.map((pub, index) => (
          <div key={index} className="position-relative">
            <a
              href={pub.linkUrl || "#"}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <div
                style={{
                  backgroundColor: '#f8f9fa',
                  borderRadius: '10px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                  textAlign: 'center'
                }}
              >
                {/* Image de la pub */}
                <img
                  src={pub.imageUrl || "https://via.placeholder.com/300x300/6C757D/FFFFFF?text=Pub"}
                  alt={pub.title || "Publicité"}
                  style={{
                    width: '100%',
                    height: '300px',
                    objectFit: 'cover',
                    borderTopLeftRadius: '10px',
                    borderTopRightRadius: '10px'
                  }}
                />
                {/* Titre ou légende */}
                <div
                  style={{
                    padding: '12px',
                    backgroundColor: 'white',
                    borderBottomLeftRadius: '10px',
                    borderBottomRightRadius: '10px'
                  }}
                >
                  <h6
                    style={{
                      margin: 0,
                      fontSize: '0.95rem',
                      fontWeight: 'bold',
                      color: '#333',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {pub.title || "Offre spéciale"}
                  </h6>
                  <small className="text-muted" style={{
                    display: 'block',
                    marginTop: '4px'
                  }}>
                    {pub.content || "Découvrez notre sélection"}
                  </small>
                </div>
              </div>
            </a>
          </div>
        ))
      ) : (
        // 🔹 Pub par défaut (quand aucune donnée)
        [1, 2, 3].map((_, index) => (
          <div key={index} className="position-relative">
            <div
              style={{
                backgroundColor: '#f8f9fa',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                textAlign: 'center'
              }}
            >
              <div
                style={{
                  height: '300px',
                  background: index === 0
                    ? 'linear-gradient(45deg, #FF6B6B, #FF8E53)'
                    : index === 1
                      ? 'linear-gradient(45deg, #4ECDC4, #44A08D)'
                      : 'linear-gradient(45deg, #6A93CB, #5A7DBA)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  fontSize: '1.2rem',
                  fontWeight: 'bold',
                  borderTopLeftRadius: '10px',
                  borderTopRightRadius: '10px'
                }}
              >
                {index === 0 && <>🔥 Soldes Été</>}
                {index === 1 && <>🚚 Livraison Gratuite</>}
                {index === 2 && <>📱 Nouveaux Smartphones</>}
              </div>
              <div
                style={{
                  padding: '12px',
                  backgroundColor: 'white',
                  borderBottomLeftRadius: '10px',
                  borderBottomRightRadius: '10px'
                }}
              >
                <h6
                  style={{
                    margin: 0,
                    fontSize: '0.95rem',
                    fontWeight: 'bold',
                    color: '#333'
                  }}
                >
                  {index === 0 ? 'Jusqu’à -70%' : index === 1 ? 'En 24h partout' : 'Derniers modèles'}
                </h6>
                <small className="text-muted">Promotion</small>
              </div>
            </div>
          </div>
        ))
      )}
    </Carousel>
  );
};

export default PublicationsCarousel;